import { useTranslation } from "react-i18next";
import React from "react";

const ForYou = () => {
  const { t } = useTranslation("about");

  return (
    <section className="padding-x md-max:px-6 md-max:py-10 flex flex-col items-center gap-12">
      <h4 className="text-center text-6xl md-max:text-4xl font-semibold">
        {t("forYou.title")?.split(" ")?.[0]}{" "}
        <span className="text-[#1C75BC]">
          {t("forYou.title").split(" ").slice(1).join(" ")}
        </span>
      </h4>
      <p className="text-center max-w-[70%] text-lg md-max:max-w-full">
        {t("forYou.description")}
      </p>
      <div className="grid grid-cols-3 gap-x-8 gap-y-14 md-max:grid-cols-1">
        {t("forYou.cards", { returnObjects: true }).map((item) => (
          <div
            key={item.id}
            className="flex h-90 flex-col items-center gap-6 rounded-3xl px-8 py-14 text-center md-max:h-auto"
            style={{ background: item.background }}
          >
            <p
              className="font-phudu text-3xl font-bold uppercase"
              style={{ color: item.color }}
            >
              {item.title}
            </p>
            <p
              className="font-phudu text-base font-normal"
              style={{ color: item.color }}
            >
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ForYou;
